import type {Abi} from "viem";
import smeltAbi from "./abi-smelt.json";

/** Smelt consumer contract ABI (auto-generated from Foundry build). */
export const SMELT_ABI = smeltAbi as unknown as Abi;

/** RitualWallet ABI — balance + lock + deposit views the UI surfaces. */
export const RITUAL_WALLET_ABI = [
  {
    inputs: [{name: "account", type: "address"}],
    name: "balanceOf",
    outputs: [{type: "uint256"}],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{name: "account", type: "address"}],
    name: "lockUntil",
    outputs: [{type: "uint256"}],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{name: "lockDuration", type: "uint256"}],
    name: "deposit",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [{name: "amount", type: "uint256"}],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const satisfies Abi;

/** TEEServiceRegistry — to discover executor teeAddress / publicKey off-chain. */
export const TEE_SERVICE_REGISTRY_ABI = [
  {
    inputs: [
      {name: "capability", type: "uint8"},
      {name: "checkValidity", type: "bool"},
    ],
    name: "getServicesByCapability",
    outputs: [
      {
        type: "tuple[]",
        components: [
          {
            name: "node",
            type: "tuple",
            components: [
              {name: "paymentAddress", type: "address"},
              {name: "teeAddress", type: "address"},
              {name: "teeType", type: "uint8"},
              {name: "publicKey", type: "bytes"},
              {name: "endpoint", type: "string"},
              {name: "certPubKeyHash", type: "bytes32"},
              {name: "capability", type: "uint8"},
            ],
          },
          {name: "isValid", type: "bool"},
          {name: "workloadId", type: "bytes32"},
        ],
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const satisfies Abi;
